var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mural-card" }, [
    _c(
      "div",
      {
        staticClass: "flex items-center justify-between mb-1",
        staticStyle: { gap: "1rem" },
      },
      [
        _c("h4", { staticClass: "mb-0 mural-side-title" }, [
          _vm._v(_vm._s(_vm.$t("mural.sales.title"))),
        ]),
        _c("b-badge", { attrs: { variant: "light-primary", pill: "" } }, [
          _vm._v(_vm._s(_vm.periodLabel)),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex flex-column", staticStyle: { gap: ".9rem" } },
      [
        _vm._l(_vm.rows, function (sale) {
          return _c("div", { key: sale.order_id, staticClass: "mural-sale" }, [
            _c(
              "span",
              { staticClass: "mural-sale__avatar", style: sale.avatarStyle },
              [_vm._v(_vm._s(sale.initials))]
            ),
            _c("div", { staticClass: "mural-sale__main" }, [
              _c("div", { staticClass: "mural-sale__name" }, [
                _vm._v(_vm._s(sale.buyer)),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex items-center",
                  staticStyle: { gap: ".4rem", "min-width": "0" },
                },
                [
                  _c(
                    "b-badge",
                    {
                      staticClass: "mural-sale__tag",
                      attrs: {
                        variant: sale.isPlan
                          ? "light-primary"
                          : "light-warning",
                        pill: "",
                      },
                    },
                    [_vm._v(" " + _vm._s(sale.type_label) + " ")]
                  ),
                  _c("span", { staticClass: "mural-sale__item" }, [
                    _vm._v(_vm._s(sale.item)),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "mural-sale__value" }, [
              _c("div", { staticClass: "font-weight-bold hb-money" }, [
                _vm._v(_vm._s(_vm.money(sale.value))),
              ]),
              _c("div", { staticClass: "text-muted" }, [
                _c("small", [_vm._v(_vm._s(sale.when))]),
              ]),
            ]),
          ])
        }),
        !_vm.rows.length
          ? _c("div", { staticClass: "text-center text-muted py-3" }, [
              _c("small", [_vm._v(_vm._s(_vm.$t("mural.sales.empty")))]),
            ])
          : _vm._e(),
      ],
      2
    ),
    _c("div", { staticClass: "mural-sale__total" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("mural.sales.total")))]),
      _c("strong", { staticClass: "hb-money" }, [
        _vm._v(_vm._s(_vm.money(_vm.total))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }